// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  /* max-width: 90% !important; */
  max-height: 90vh;
  font-size: 36px;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-right: 0px !important
}

.modal-dialog.modal-lg {
  max-width: 90%;
  /* z-index: 999; */
}

.cut-word1 {
  /* width: 11em; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.alert-warning {
  color: #856404;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  WIDTH: fit-content;
}

.modal-body {
  height: 500px !important;
  overflow: scroll !important; 
}
.cut-word{
  max-width: 25em !important;
}




.category {
  background: #f5f5f5;
  border-radius: 15px;
}
 

.tooltip{
  z-index: 999999999 !important;
}

 `, "",{"version":3,"sources":["webpack://./src/app/views/menus/add-edit-menu/add-edit-menu.component.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;;;;;AAKA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;AAGA;EACE,6BAA6B;AAC/B","sourcesContent":[".modal-content {\r\n  /* max-width: 90% !important; */\r\n  max-height: 90vh;\r\n  font-size: 36px;\r\n  padding: 20px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  margin-right: 0px !important\r\n}\r\n\r\n.modal-dialog.modal-lg {\r\n  max-width: 90%;\r\n  /* z-index: 999; */\r\n}\r\n\r\n.cut-word1 {\r\n  /* width: 11em; */\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.alert-warning {\r\n  color: #856404;\r\n  background-color: #f8d7da;\r\n  border-color: #f5c6cb;\r\n  WIDTH: fit-content;\r\n}\r\n\r\n.modal-body {\r\n  height: 500px !important;\r\n  overflow: scroll !important; \r\n}\r\n.cut-word{\r\n  max-width: 25em !important;\r\n}\r\n\r\n\r\n\r\n\r\n.category {\r\n  background: #f5f5f5;\r\n  border-radius: 15px;\r\n}\r\n \r\n\r\n.tooltip{\r\n  z-index: 999999999 !important;\r\n}\r\n\r\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
